/* app/js/src/components/common/multi-checkbox-selection/multi-checkbox-selection.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  display: flex;
  padding-bottom: 15px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  flex: 1 0 0;
}
.checkbox-item-group {
  display: flex;
  padding: 10px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
}
.checkbox-item-group .name {
  color: rgba(0, 0, 0, 0.85);
  font-family: Open Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  position: relative;
  -webkit-user-select: none;
  user-select: none;
}
/*# sourceMappingURL=multi-checkbox-selection.css.map */
